function JobStatusIcon(props) {
  const { isActive } = props
  return (
    <svg
      width="12"
      height="16"
      viewBox="0 0 12 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.66667 0.666687H9.33333V2.00002H12V15.3334H0V2.00002H2.66667V0.666687ZM2.66667 3.33335H1.33333V14H10.6667V3.33335H9.33333V4.66669H2.66667V3.33335ZM8 2.00002H4V3.33335H8V2.00002ZM4 7.33335H8V8.66669H4V7.33335ZM4 10H8V11.3334H4V10Z"
        fill={!isActive ? '#828282' : '#FFFFFF'}
      />
    </svg>
  )
}

export default JobStatusIcon
